import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { FuseConfigService } from '../../core/services/config.service';
import { AuthService } from '../content/Seguridad/auth.service'
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { ServiciosGenerales } from '../content/Servicios/ServiciosGenerales.service';
import { md5 } from '../content/Global/md5';


@Component({
    selector   : 'fuse-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls  : ['./toolbar.component.scss']
})

export class FuseToolbarComponent
{
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    showLoadingBar: boolean;
    horizontalNav: boolean;
    public nombreUsuario:string="";
    public alertaDias : string = "";

    constructor(
        private router: Router,
        private fuseConfig: FuseConfigService,
        private authService:AuthService, 
        private serviciosGenerales:ServiciosGenerales, 
        private dialog: MatDialog
        )
    {
        this.userStatusOptions = [
        {
            'title': 'Online',
            'icon' : 'icon-checkbox-marked-circle',
            'color': '#4CAF50'
        },
        {
            'title': 'Away',
            'icon' : 'icon-clock',
            'color': '#FFC107'
        },
        {
            'title': 'Do not Disturb',
            'icon' : 'icon-minus-circle',
            'color': '#F44336'
        },
        {
            'title': 'Invisible',
            'icon' : 'icon-checkbox-blank-circle-outline',
            'color': '#BDBDBD'
        },
        {
            'title': 'Offline',
            'icon' : 'icon-checkbox-blank-circle-outline',
            'color': '#616161'
        }
        ];

        this.languages = [
        {
            'id'   : 'en',
            'title': 'English',
            'flag' : 'us'
        },
        {
            'id'   : 'es',
            'title': 'Spanish',
            'flag' : 'es'
        },
        {
            'id'   : 'tr',
            'title': 'Turkish',
            'flag' : 'tr'
        }
        ];

        this.selectedLanguage = this.languages[0];

        router.events.subscribe(
            (event) => {
                if ( event instanceof NavigationStart )
                {
                    this.showLoadingBar = true;
                }
                if ( event instanceof NavigationEnd )
                {
                    this.showLoadingBar = false;
                }
            });

        this.fuseConfig.onSettingsChanged.subscribe((settings) => {
            this.horizontalNav = settings.layout.navigation === 'top';
        });

        if(authService.isAuthenticated() == true){
            this.nombreUsuario = JSON.parse(authService.getInfoToken().nombreusuario).nombreusuario;    
        }
        //console.log('INFORMACIÓN DEL TOKEN : ', JSON.parse(serviciosGenerales.seguridad.getInfoToken()['dias']));
        if(serviciosGenerales.seguridad.getToken() != undefined && serviciosGenerales.seguridad.getToken() != ''){
            //console.log("---------------> ",serviciosGenerales.seguridad.getToken());
            if(serviciosGenerales != undefined && serviciosGenerales.seguridad != undefined && serviciosGenerales.seguridad.getInfoToken()['dias'] != undefined){
                let dias = JSON.parse(serviciosGenerales.seguridad.getInfoToken()['dias']).dias;
                if(dias >= 50){
                    this.alertaDias = "Alerta: En "+dias+" días vence la contraseña, por favor cambiarla.";
                }
            }
        }
    }

    

    search(value)
    {

        // Do your search here...
        console.log(value);
    }

    public cerrarSesion(){
                                                       
        this.serviciosGenerales.post('guardar/cierreSesion', {usuario : this.serviciosGenerales.seguridad.getInfoSesion().usuario,empresa : JSON.parse(this.serviciosGenerales.seguridad.getInfoToken().empresa).empresa}).subscribe(x=>{
            var ingresoEmpresa = JSON.parse(this.serviciosGenerales.seguridad.getInfoToken().empresa).empresa;
            this.router.navigate([ingresoEmpresa.indexOf("VICTIMAS") == 0 ? "/victimas":""]);
            this.authService.clearSession(this.serviciosGenerales);
        });
    }

    public cambiarClave(){
        let dialogRef = this.dialog.open(CambioClave);
        dialogRef.afterClosed().subscribe(r=>{
            console.log(r, ' <-------------------- ');
        })
    }
}


export class cambioClave{
    constructor(public validarPass : number, public passOriginal : string, public passAnt : string, public passNew : string, public usuario : string){}
}

@Component({
    selector: 'CambioClave',
    templateUrl: 'dialogCambioPass.component.html',
})
export class CambioClave {


    public passAnt:string = '';
    public passNew:string = '';
    public passConfirmNew:string = '';
    public form: FormGroup;
    public formErrors: any;
    public bloquear:boolean = true;

    public x: cambioClave;

    constructor( private formBuilder: FormBuilder, public dialogRef: MatDialogRef<CambioClave>, @Inject(MAT_DIALOG_DATA) public data:Array<string>, private _serviciosGenerales:ServiciosGenerales,
        public snackBar: MatSnackBar) {

        this.formErrors = {

            passAnt : {},
            passNew : {},
            passConfirmNew : {}
            
        };

        this.inicializarForm();
        
        

    }

    private inicializarForm(){
        
        this.form = this.formBuilder.group({
            passAnt : [this.passAnt, Validators.required],
            passNew : ['', Validators.compose([Validators.required, Validators.minLength(14)])],
            passConfirmNew : ['', Validators.compose([Validators.required, Validators.minLength(14)])]
            
        });

        this.form.valueChanges.subscribe(() => {
            this.onFormValuesChanged();
        });
    }


    validarPassAnt(){
        this.x = new cambioClave(1, this.passNew, this.passAnt, this.passNew, this._serviciosGenerales.seguridad.getInfoSesion().usuario);

        this._serviciosGenerales.post('cambiar/clave', this.x).subscribe(result=>{

            if(result.c == 0){
                this.openSnackBar("La contraseña es incorrecta", "X" );
                this.bloquear = true;
                this.inicializarForm();
            }else{
                this.bloquear = false;    
                this.inicializarForm();
            }

        }, error=>{
            console.log(error, '');
            this.openSnackBar("Ocurrió un error al momento de validar la contraseña", "X" );
        })

    }


    guardar(){
        if(this.passNew != this.passConfirmNew){
            this.openSnackBar("Las contraseñas son diferentes", "X");
            return;
        }


        this.x = new cambioClave(0, this.passNew, this.passAnt, this.passNew, this._serviciosGenerales.seguridad.getInfoSesion().usuario);

        this._serviciosGenerales.post('cambiar/clave', this.x).subscribe(result=>{

            this.openSnackBar(result.mensaje, "X" );
            
            if(result.error == false)
                this.dialogRef.close();


        }, error=>{
            console.log(error, '');
            this.openSnackBar("Ocurrió un error al momento de actualizar la contraseña", "X");
        })

        
    }

    onNoClick(): void {
        this.dialogRef.close();
    }


    onFormValuesChanged()
    {
        for ( const field in this.formErrors )
        {
            if ( !this.formErrors.hasOwnProperty(field) )
            {
                continue;
            }

            // Clear previous errors
            this.formErrors[field] = {};

            // Get the control
            const control = this.form.get(field);

            if ( control && control.dirty && !control.valid )
            {
                this.formErrors[field] = control.errors;
            }
        }
    }

    openSnackBar(message: string, action: string)
    {
        this.snackBar.open(message, action, {
            duration: 20000
        });
    }

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/toolbar/toolbar.component.ts